import { render, staticRenderFns } from "./Coordination.vue?vue&type=template&id=3b96165c&scoped=true&"
import script from "./Coordination.vue?vue&type=script&lang=ts&"
export * from "./Coordination.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b96165c",
  null
  
)

export default component.exports